import styled from 'styled-components';
import { colors, overline, spacing } from 'ui/theme';
import { SideNavLinkList } from '../SideNavLinkList';
import { SideNavSectionConfig } from '../types';

const Wrapper = styled.div`
  min-width: ${spacing.x12};
  margin-right: ${spacing.base};
`;

const Header = styled.div`
  ${overline};
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.half};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  border-left: ${spacing.single} solid ${colors.borderPrimary};
  padding-left: ${spacing.threeQuarter};
  margin-bottom: ${spacing.plusHalf};
`;

export const NormalSideNavSection = ({ header, links }: SideNavSectionConfig) => {
  return (
    <Wrapper>
      <Header>{header}</Header>
      <Container>
        <SideNavLinkList linksOrSection={links} />
      </Container>
    </Wrapper>
  );
};
